import {Api, LicenseTester, StringUtil, UserSettings} from "@mcleod/core";

export class SmsService {
    private static readonly SMS_LICENSE_CLASS = "com.tms.client.loadmaster.sms";

    public static async getDefaultSmsOptIn(): Promise<boolean> {

        if (!this.isSmsFeatureLicensed()) {
            return false;
        }

        const defaultSmsOptInSetting = UserSettings.getSingleton().getSmsOptInDefault();

        if (defaultSmsOptInSetting != null) {
            return StringUtil.equalsIgnoreCase("Y", defaultSmsOptInSetting);
        } else {
            const response = await Api.search("lme/powerbroker/sms-control");
            return StringUtil.equalsIgnoreCase("Y",response?.data?.[0]?.opt_in_default) ?? false;
        }
    }

    public static isSmsFeatureLicensed(): boolean {
        return LicenseTester.testPackage(this.SMS_LICENSE_CLASS);
    }

}
